import React from "react";
import './Landing.css';

const Landing=() =>{
    return(
        <>
            <div id="home" className="landing">
           
                <div className="landing_image">
                    <img className="landing_image1" src="https://res.cloudinary.com/dzbdnlr0f/image/upload/v1632564967/plaocter/New_Project_5_k2ev61.svg" alt=""/>
                </div>

                <div className="landing_text">
                    <h1>PLAOCTER</h1>
                    <h2>BECAUSE WE CARE ABOUT YOUR PLANTS</h2>
                </div>
        
            </div>
        </>
    )
}

export default Landing;